import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import {
  SourcingSharedCustomizeMessageEmailFormData,
  SourcingSharedCustomizeMessageSmsFormData
} from 'modules/sourcing-shared/forms';
import { getEditedOpenMessageToUpdate } from '../getEditedOpenMessageToUpdate';
import { scrollToTop } from 'common';
import { Channels } from 'generated-graphql/types';

export type HandleSourcingSharedCustomizeMessageNextDataProps = {
  firstCandidateInListId: string;
  customizeMessageFormData:
    | SourcingSharedCustomizeMessageEmailFormData
    | SourcingSharedCustomizeMessageSmsFormData;
};

type HandleSourcingSharedCustomizeMessageNextControllerProps =
  HandleSourcingSharedCustomizeMessageNextDataProps & {
    get: SharedSourcingStoreApi['getState'];
    set: SharedSourcingStoreApi['setState'];
  };

export const handleSourcingSharedCustomizeMessageNextController = ({
  firstCandidateInListId,
  customizeMessageFormData,
  get,
  set
}: HandleSourcingSharedCustomizeMessageNextControllerProps) => {
  const {
    applicationFormData,
    defaultStartingTemplatedMessage,
    selectedCustomizeCandidateId,
    editedOpeningMessage,
    channelFormData
  } = get();

  if (!applicationFormData) {
    return;
  }

  const editedOpeningMessageToUpdate = getEditedOpenMessageToUpdate({
    campaignType: applicationFormData.campaignType,
    defaultStartingTemplatedMessage,
    editedOpeningMessage,
    customTemplatedMessage: customizeMessageFormData.customTemplatedMessage,
    channelType: channelFormData?.channel ?? Channels.Email
  });

  scrollToTop();

  set({
    step: 'REVIEW_INVITATIONS',
    customizeMessageFormData,
    selectedCustomizeCandidateId:
      selectedCustomizeCandidateId ?? firstCandidateInListId,
    editedOpeningMessage: editedOpeningMessageToUpdate
  });
};
